export const SMS_SEND_USER_MOBILE = "0313553329"